import moment from 'moment';

export const defaultFilters = () => {
  return {
    dates: [
      moment().add(-1, 'month').add(1, 'day').format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD')
    ],
    line_id: null,
    brand_id: null,
    branch_office_id: null,
    branch_office_warehouse_id: null
  };
};

export default {
  consolidated_kardex: [],
  preloader: false,
  lines: [],
  brands: [],
  branch_offices: [],
  branch_offices_warehouses: [],
  filters: defaultFilters()
};



// WEBPACK FOOTER //
// ./src/modules/consolidated_kardex/state.js